import { ZyMyProfile } from '@/components/common/zymyprofile-dialog';
import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';
import authService from '@/services/zybook-auth-service';
import { CircleUserRound } from 'lucide-react';
import { useCallback, useState } from 'react';

export function ZyProfileSidebarItem() {
    const [profileOpen, setProfileOpen] = useState(false);
    const { open: sidebarPinnedOpen, setHoverExpanded, cancelHoverExpandCollapse } = useSidebar();
    const fullName = authService.getUserFullName();

    const collapseHoverRail = useCallback(() => {
        if (sidebarPinnedOpen) return;
        cancelHoverExpandCollapse();
        setHoverExpanded(false);
    }, [sidebarPinnedOpen, cancelHoverExpandCollapse, setHoverExpanded]);

    const handleProfileOpenChange = useCallback(
        (nextOpen: boolean) => {
            setProfileOpen(nextOpen);
            collapseHoverRail();
        },
        [collapseHoverRail],
    );

    return (
        <>
            <SidebarMenuItem>
                <SidebarMenuButton
                    tooltip={fullName ?? undefined}
                    onClick={() => handleProfileOpenChange(true)}
                >
                    <CircleUserRound className="h-4 w-4" />
                    <span className="truncate">{fullName}</span>
                </SidebarMenuButton>
            </SidebarMenuItem>

            <ZyMyProfile
                showMyProfileModal={profileOpen}
                setShowMyProfileModal={handleProfileOpenChange}
            />
        </>
    );
}
